<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 头部顶部 -->
    <!-- <div class="header-top container-fuild hidden-xs">
      <div class="container">
        <div class="server pull-left">
          <span class="glyphicon glyphicon-earphone"></span>888-888-888
          <span class="glyphicon glyphicon-envelope"></span>xxx@163.com
          <span class="glyphicon glyphicon-time"></span>7x24小时为您服务
        </div>
        <div class="shejiao pull-right">
          <span class="glyphicon glyphicon-hand-right"></span>赶快联系我们吧！
          <span class="glyphicon glyphicon-hand-left"></span>
        </div>
      </div>
    </div> -->
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img src="@/assets/img/logo.png">
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li v-for="(item, index) in navList" :key="index" :class="index == navindex ? 'active' : ''"
          @click="navClick(index, item.name)">
          <router-link :to="item.path">
            {{ $t(`nav.${item.i18nKey}`) }}
            <span v-if="item.children.length > 0" class="glyphicon glyphicon-menu-down"></span>
            <i class="underline"></i>
          </router-link>
          <dl v-if="item.children.length > 0">
            <dt v-for="(i, n) in item.children" :key="n">
              <router-link :to="i.path">{{ $t(`nav.${i.i18nKey}`) }}</router-link>
            </dt>
          </dl>
        </li>
      </ul>
      
      <!-- 语言切换 -->
      <div class="language-switch">
        <el-dropdown @command="handleLanguageChange">
          <span class="el-dropdown-link">
            {{ language === 'zh-CN' ? '中文' : 'English' }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="zh-CN">中文</el-dropdown-item>
            <el-dropdown-item command="en">English</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      
      <img :src="currentLanguage == 'zh-CN' ? lianxi : lianxi_en" class="lianxi" :alt="$t('contact.contactUs')" @click="dialogVisible = true">
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo">
        <img class="center-block" src="@/assets/img/logo.png" alt="logo">
      </div>

      <div class="header-nav-m-menu text-center">
        {{ menuName }}
        <div class="header-nav-m-menu-wrapper" data-toggle="collapse" data-target="#menu" @click="menuClick">
          <span :class="menuClass"></span>
        </div>

        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li v-for="(item, index) in navList" :key="index" :class="index == navIndex ? 'active' : ''"
            @click="navClick(index, item.name)" data-toggle="collapse" data-target="#menu">
            <router-link :to="item.path">
              {{ $t(`nav.${item.i18nKey}`) }}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
        
        <!-- 移动端语言切换 -->
        <div class="mobile-language-switch">
          <el-dropdown @command="handleLanguageChange">
            <span class="el-dropdown-link">
              {{ language === 'zh-CN' ? '中文' : 'EN' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="zh-CN">中文</el-dropdown-item>
              <el-dropdown-item command="en">English</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>

    <el-dialog :title="$t('header.dialogTitle')" :append-to-body="true" :visible.sync="dialogVisible" width="30%">
      <h4 style="font-weight: bold;text-align: center;">{{ $t('header.scanQrCode') }}</h4>
      <img :src="baseConfig.ownQR == '' ? '../assets/img/qrcode.jpg' : baseConfig.ownQR" :alt="$t('header.contactQrCodeAlt')" srcset=""
        class="logo">
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t('header.cancel') }}</el-button>
        <el-button type="primary" @click="dialogVisible = false">{{ $t('header.confirm') }}</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
import { baseConfig } from '../api/api'
import { mapState, mapGetters, mapActions } from 'vuex'
import lianxi from '@/assets/img/lianxi.png'
import lianxi_en from '@/assets/img/en/lianxi.png'
export default {
  name: "Header",
  watch: {
    navIndex(newval, oldval) {

    }
  },
  computed: {
    ...mapState(['navindex', 'language']),
    ...mapGetters(['currentLanguage'])
  },
  data() {
    return {
      lianxi,
      lianxi_en,
      baseConfig: {},
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "首页",
          i18nKey: "home",
          path: "/",
          children: []
        },
        {
          name: "跨境联盟",
          i18nKey: "introduce",
          path: "/software",
          children: [
            // {
            //   name: "智能小镇管理系统",
            //   path: "/software/smartTown"
            // },
            // {
            //   name: "大数据管理系统",
            //   path: "/software/bigData"
            // }
          ]
        },
        {
          name: "产品服务",
          i18nKey: "service",
          path: "/service",
          children: []
        },
        {
          name: "行业资讯",
          i18nKey: "news",
          path: "/newsinformation",
          children: []
        },
        {
          name: "合作加盟",
          i18nKey: "join",
          path: "/companyintroduction",
          children: []
        },
        // {
        //   name: "工作机会",
        //   path: "/jobchance",
        //   children: []
        // },
        // {
        //   name: "联系我们",
        //   path: "/contactus",
        //   children: []
        // }
      ],
      dialogVisible: false
    };
  },
  mounted() {
    this.getConfig();
    this.initLanguageFun();
  },
  methods: {
    ...mapActions(['initLanguage', 'changeLanguage']),
    getConfig() {
      baseConfig()
        .then(res => {
          let obj = JSON.parse(res.data.body);
          console.log(obj)
          this.baseConfig = { ...obj }
        })
        .catch(err => {

        })
      console.log(window.location.hash)
      let path = window.location.hash;
      console.log(path)
      let arr = ['#/home', '#/software', '#/service', '#/newsinformation', '#/companyintroduction']
      let eindex = arr.findIndex(value=>value==path);
      console.log(eindex)
      this.$store.commit('setIndex', eindex)
      sessionStorage.setItem('navIndex', eindex)
    },
    navClick(index, name) {
      this.navIndex = index;
      this.$store.commit('setIndex', index)
      sessionStorage.setItem('navIndex', index)
      this.menuName = this.$t(`nav.${this.navList[index].i18nKey}`);
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
    handleLanguageChange(lang) {
      this.$i18n.locale = lang;
      this.changeLanguage(lang);
      
      // 更新菜单名称
      const activeNav = this.navList[this.navIndex];
      if (activeNav) {
        this.menuName = this.$t(`nav.${activeNav.i18nKey}`);
      }
      
      // 刷新页面以应用语言更改
      setTimeout(() => {
        window.location.reload();
      }, 100);
    },
    initLanguageFun() {
      // 初始化语言
      this.initLanguage().then(() => {
        this.$i18n.locale = this.currentLanguage;
        
        // 更新菜单名称
        const activeNav = this.navList[this.navIndex];
        if (activeNav) {
          this.menuName = this.$t(`nav.${activeNav.i18nKey}`);
        }
      });
    }
  }
};
</script>
<style scoped>
/* 顶部 */
#header {
  background: rgba(237, 236, 235, 0.86);
  transition: all ease 0.6s;
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 999;
}

#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}

/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}

/* 导航栏 */
#header .header-nav {
  height: 72px;
  width: 100%;
  padding: 0;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  position: relative;
}

/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 28.85%;
  height: 100%;
  /* opacity: 0.58; */
  margin-right: 30px;
  background-color: #004984;
  position: relative;
}

/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 70%;
  height: auto;
  max-height: 72px;
  max-width: 184px;
  position: absolute;
  left: 40px;
  top: 10px;
  /* right: 0;
  bottom: 0; */
  margin: auto;
}

/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  background-color: #EFEFEF;
  line-height: 50px;
}

#header .header-nav .header-nav-wrapper {
  line-height: 90px;
  float: right;
  margin: 0;
  max-width: 900px;
}

/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper>li {
  float: left;
  margin: 0 2vw;
  position: relative;
}

/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper>li>a {
  color: #004984;
  font-size: 20px;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
}

/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper>li>a>i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #1e73be;
}

/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper>li>a>span {
  font-size: 12px;
  transition: transform ease 0.5s;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover {
  color: #1e73be;
  text-decoration: none;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover span {
  transform: rotate(180deg);
}

/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper>li.active>a {
  color: #1e73be;
  text-decoration: none;
  border-bottom: 2px solid #1e73be;
}

/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper>li>dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper>li>dl>dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper>li>dl>dt>a:hover {
  text-decoration: none;
}

/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper>li:hover dl {
  display: block;
}

#header .header-nav .header-nav-wrapper>li>dl>dt:hover {
  cursor: pointer;
  background: #ccc;
}

.logo {
  width: 80%;
  margin: auto;
}

.lianxi {
  width: 160px;
  position: absolute;
  height: 72px;
  right: 0;
  top: 0;
  cursor: pointer;
}

/* 语言切换 */
.language-switch {
  position: absolute;
  right: 180px;
  top: 50%;
  transform: translateY(-50%);
  color: #004984;
  font-size: 16px;
}

.mobile-language-switch {
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  color: #fff;
  font-size: 14px;
}

.el-dropdown-link {
  cursor: pointer;
  color: #004984;
}

.mobile-language-switch .el-dropdown-link {
  color: #fff;
}

@media screen and (max-width: 768px) {
  #header .header-nav-m {
    position: relative;
  }

  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 60px;
    position: relative;
    background-color: #1e73be;
  }

  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 160px;
    height: 44px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }

  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 16px;
    line-height: 50px;
    background: #1e73be;
    position: relative;
  }

  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }

  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #004984;
    z-index: 9999999;
  }

  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper>li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }

  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper>li>a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    /* padding: 15px 0; */
    position: relative;
    width: 100%;
    display: inline-block;
    text-align: center;
  }

  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper>li>a>span {
    font-size: 10px;
  }
}

@media screen and (min-width: 768px) and (max-width: 1250px) {

  /* 导航栏 每个导航 */
  #header .header-nav .header-nav-wrapper>li {
    margin: 0 10px;

    a {
      font-size: 14px;
    }
  }
  
  .language-switch {
    right: 200px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Header.vue